import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks'; // ✅ Footer
import BurgerHint from '../../components/layout/BurgerHint';   // ✅ Burger Tip!

const PrivacyPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>🔐 Privacy & Trust</h1>

        {/* 🍔 Burger Menu Tip */}
        <BurgerHint />

        <p>
          When it comes to your data, we believe in honesty, protection, and respect. Here’s what that means:
        </p>

        <ul>
          <li>🌼 <strong>Your data stays yours.</strong> We don’t sell it. We don’t share it. Period.</li>
          <li>🧠 <strong>dAIsy remembers only for you.</strong> Your memories are private by default — no one else can see them.</li>
          <li>🔑 <strong>Secure memory keys.</strong> Your data is stored using randomly generated, encrypted keys created at runtime.</li>
          <li>🧩 <strong>We can’t even peek.</strong> We never see your memory content — it’s fully isolated and yours alone.</li>
        </ul>

        <p className="mt-6"><strong>Obfuscation & Separation</strong></p>

        <p>
          Anything dAIsy recalls — like memories, relationships, or emotions — is never stored in human-readable form.
          It’s saved using secure obfuscation, meaning no one can see or access it directly.
        </p>
        <p>
          These memories are kept completely separate from your basic account info (like name, email, or subscription),
          which is only used to run the app securely.
        </p>
        <p>
          <strong>
            <span style={{ color: '#111827' }}>d</span>
            <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
            <span style={{ color: '#111827' }}>sy</span>
          </strong>
          &nbsp;
          remembers what matters to you — but no one else can access or read what she knows, <strong>even us</strong>.
        </p>

        <p className="mt-4">
          We’ve built&nbsp;
          <strong>
            <span style={{ color: '#111827' }}>d</span>
            <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
            <span style={{ color: '#111827' }}>sy</span>
          </strong>
          &nbsp;with care and intention — to remember what matters, not to pry. If you ever have concerns,{' '}
          <strong><a href="/contact" className="hover:underline">reach out</a></strong>. We’re here.
        </p>

        {/* Footer */}
        <FooterLinks />
      </div>
    </div>
  );
};

export default PrivacyPage;
